import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';
import RoutesApp from '../../routes';

//Servicios
import { DeclaracionesService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import DJCVSearch from './DJCVSearch';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';

function DJCVSearchContainer() {
    const { masters, SearchParameters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.DJCVPage, [state.DJCVPage]);

    const [loader, setLoader] = useState(false);
    const [tableData, setTableData] = useState(buildTableData());
    let apiTablePages;

    useEffect(() => {
        const getDJCVSearchCuantity = async () => {
            try {
                setLoader(true);

                const DJCVSearchCuantity =
                    await DeclaracionesService.totalRecords({
                        ...SearchParameters.declaraciones,
                        tipo: 7,
                    });

                if (DJCVSearchCuantity) {
                    apiTablePages = DJCVSearchCuantity.data;

                    getDJCVSearch();
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getDJCVSearchCuantity();
    }, [SearchParameters.declaraciones]);

    async function getDJCVSearch() {
        try {
            setLoader(true);

            const DJCVSearch = await DeclaracionesService.search({
                ...SearchParameters.declaraciones,
                tipo: 7,
                pagina: tablePage,
            });

            if (DJCVSearch) {
                setTableData(buildTableData(DJCVSearch.data, apiTablePages));
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    }

    /**Funcion que crea el objeto para crear la tabla resultado del buscador de DJCVs */
    function buildTableData(data = [], tablePages) {
        return {
            title: 'Declaraciones de DJCV',
            headers: [
                'ID',
                'Viñedo',
                'Titulares',
                'Fecha',
                'Departamento',
                'Seccional',
                ' ',
            ],
            tablePages,
            pagination: 10,
            pageType: 'DJCVPage',
            data:
                data.length > 0
                    ? data.map((dj) => {
                          return {
                              id: `${dj.serie}-C-${dj.numero}`,
                              viniedo: dj.viniedo,
                              titulares: dj.titulares,
                              fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                              departamento: masters.Departments?.find(
                                  (ht) => ht.id === dj.departamento
                              )?.nombre.replaceAll('_', ' '),
                              kilosTotales: dj.seccional,
                              icons: (
                                  <div>
                                      <Link
                                          to={
                                              RoutesApp.Declaraciones
                                                  .cosechaProbable + dj.id
                                          }
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    }

    return loader ? <Spinner /> : <DJCVSearch tableData={tableData} />;
}

export default DJCVSearchContainer;
